import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "input"]

  declare selectTarget: HTMLSelectElement
  declare inputTarget: HTMLInputElement

  connect() {
    this.toggle()
  }

  toggle() {
    const isOther = this.selectTarget.value === "__other__"
    this.inputTarget.style.display = isOther ? "" : "none"
    this.inputTarget.required = isOther
    if (!isOther) {
      this.inputTarget.value = ""
    }
  }
}
